"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const iconoir_react_1 = require("iconoir-react");
// import app components
const typography_1 = __importDefault(require("../typography"));
const theme_1 = require("../../../theme");
const ImageModal = (props) => {
    const { index, images, onChangeIndex } = props;
    if (images.length === 0) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.Box, { sx: {
                position: "fixed",
                zIndex: 1400,
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                opacity: typeof index === "number" && images[index] ? 1 : 0,
                pointerEvents: typeof index === "number" && images[index] ? "all" : "none",
                transition: "ease all 0.2s",
                backgroundColor: "rgba(0,0,0,0.8)",
            }, onClick: () => onChangeIndex(null) }),
        react_1.default.createElement(material_1.Box, { sx: {
                position: "fixed",
                zIndex: 1401,
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                opacity: typeof index === "number" && images[index] ? 1 : 0,
                pointerEvents: typeof index === "number" && images[index] ? "all" : "none",
                transition: "ease all 0.2s",
            } },
            images?.[index]?.src && (react_1.default.createElement("img", { src: images[index].src, alt: images[index]?.caption || "Image", style: { maxWidth: "80vw", maxHeight: "80vh", borderRadius: "1rem" } })),
            images?.[index]?.caption && (react_1.default.createElement(typography_1.default, { sx: {
                    position: "absolute",
                    bottom: "20px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    padding: "6px 12px",
                    background: `${theme_1.colors.secondary[900]}80`,
                    borderRadius: "0.5rem",
                }, variant: "h5" }, images[index].caption))),
        typeof index === "number" && images[index] && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(material_1.IconButton, { onClick: () => onChangeIndex(null), style: { position: "fixed", zIndex: 1401, top: 20, right: 20, backgroundColor: theme_1.colors.secondary[600] } },
                react_1.default.createElement(iconoir_react_1.Cancel, { width: 18, height: 18, style: { color: theme_1.colors.icons[100] } })),
            images.length > 1 && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(material_1.IconButton, { style: {
                        position: "fixed",
                        zIndex: 1402,
                        top: "50%",
                        right: "5vw",
                        transform: "translate(-50%, -50%)",
                        backgroundColor: theme_1.colors.secondary[600],
                    }, onClick: () => (images[index + 1] ? onChangeIndex(index + 1) : null) },
                    react_1.default.createElement(iconoir_react_1.ArrowRight, { width: 18, height: 18, style: { color: theme_1.colors.icons[100] } })),
                react_1.default.createElement(material_1.IconButton, { style: {
                        position: "fixed",
                        zIndex: 1402,
                        top: "50%",
                        left: "5vw",
                        transform: "translate(-50%, -50%)",
                        backgroundColor: theme_1.colors.secondary[600],
                    }, onClick: () => (images[index - 1] ? onChangeIndex(index - 1) : null) },
                    react_1.default.createElement(iconoir_react_1.ArrowLeft, { width: 18, height: 18, style: { color: theme_1.colors.icons[100] } }))))))));
};
exports.default = ImageModal;
